/*
 * RemoveDialogWarning Messages
 *
 * This contains all the text for the RemoveDialogWarning component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.RemoveDialogWarning";

export default defineMessages(scope, {
  header: "This is the RemoveDialogWarning component!",
  cancelButtonLabel: "Cancel",
  save: "Yes, make changes",
  tryAgain: "Try again",
});
